'use client';
import React from 'react';

interface WaveDividerProps {
  color?: string;
  flip?: boolean;
}

export default function WaveDivider({ color = '#141E30', flip = false }: WaveDividerProps) {
  return (
    <svg
      preserveAspectRatio="none"
      viewBox="0 0 1200 120"
      style={{ display: 'block', width: '100%', height: '60px', transform: flip ? 'rotate(180deg)' : undefined }}
    >
      <path
        d="M0,0 C150,100 350,0 600,0 C850,0 1050,100 1200,0 L1200,120 L0,120 Z"
        fill={color}
      />
    </svg>
  );
}
